const VoiceNavigation = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.105469"
        width="95.8786"
        height="95.8786"
        rx="47.9393"
        transform="rotate(0.0638669 0.105469 0)"
      />
      <path
        d="M47.8287 68.1873C57.4359 68.198 65.2523 60.3991 65.263 50.7918L65.2791 36.2794C65.2899 26.6722 57.4909 18.8558 47.8837 18.8451C38.2764 18.8344 30.46 26.6334 30.4493 36.2406L30.4332 50.753C30.4225 60.3602 38.2214 68.1766 47.8287 68.1873Z"
        stroke="black"
        strokeWidth="5.22447"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7383 44.9395L21.7318 50.7444C21.7157 65.1698 33.3997 76.8798 47.825 76.8959C62.2504 76.912 73.9604 65.228 73.9765 50.8027L73.983 44.9977"
        stroke="black"
        strokeWidth="5.22447"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.4906 34.7421C44.6591 32.8613 50.29 32.8675 55.4543 34.7599"
        stroke="black"
        strokeWidth="5.22447"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.1437 43.4513C45.6278 42.4973 49.3139 42.5014 52.7958 43.4631"
        stroke="black"
        strokeWidth="5.22447"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VoiceNavigation;
